import { useIntl } from 'react-intl';
import type TrailTraffic from '@alltrails/trails/types/TrailTraffic';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import getVisitationLabel from '../../utils/getVisitationLabel';
import useChipsFilterConfig from './useChipsFilterConfig';

const visitationValues: TrailTraffic[] = ['light', 'moderate', 'heavy'];

const useVisitationChipsConfig = (exploreServiceFilters: ExploreServiceFilters, onFiltersChange: (updatedFilters: ExploreServiceFilters) => void) => {
  const intl = useIntl();

  return useChipsFilterConfig({
    exploreServiceFilterKey: 'trailTraffic',
    exploreServiceFilters,
    getValueLabel: trailTraffic => getVisitationLabel(intl, trailTraffic),
    label: intl.formatMessage({ defaultMessage: 'Visitation' }),
    onFiltersChange,
    values: visitationValues
  });
};

export default useVisitationChipsConfig;
